export default "data:video/mp2t;base64,ZGVjbGFyZSBtb2R1bGUgJ3BsdXJhbGl6ZSc7CmRlY2xhcmUgbW9kdWxlICdsZWFkZXItbGluZSc7Cg=="